import { render } from "./PhysicianReport.vue?vue&type=template&id=0cc8347c"
import script from "./PhysicianReport.vue?vue&type=script&lang=js"
export * from "./PhysicianReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__